export default __webpack_public_path__ + "static/media/job-interview.8c48784c.svg";